<template>
    <div class="nav-content-wrapper" v-if="!$store.state.waitingRequest">
        <admin-navbar />
        
        <div class="content">
            <h2>Ajouter un compte utilisateur</h2>
        </div>
    </div>
</template>

<script>
import Session from '../mixins/adminSession';
import AdminNavbar from '../views/AdminNavbar';

export default {
    name: 'AdminAddAccount',
    mixins: [Session],
    components: {
        'admin-navbar': AdminNavbar
    },
    data() {
        return {
            
        }
    },
    mounted() {

    },
    methods: {
        
    }
}
</script>

<style scoped src="@/assets/admin.css">
</style>
